import { MenuItem as CadArcMenuItem } from '@cad-arc';
import { ContextMenuItemView } from '@mark43/cad-api';
import { DisabledTitleWrapper } from './disabled-title-wrapper';

export function MenuItem({
    contextMenuItemView,
    onSelect,
}: {
    contextMenuItemView: ContextMenuItemView;
    onSelect: () => void;
}): React.ReactElement {
    const { disabledTitle, isVisible, isEnabled, label } = contextMenuItemView;

    if (!isVisible) {
        return <></>;
    }

    return (
        <DisabledTitleWrapper disabledTitle={disabledTitle} isEnabled={isEnabled}>
            <CadArcMenuItem isDisabled={!isEnabled} onSelect={onSelect}>
                {label}
            </CadArcMenuItem>
        </DisabledTitleWrapper>
    );
}
